import { isMyApp } from "@/utils/validate";
// import { toast } from "@luzhongk/vue-request";

// bridePromise
let bridePromise;

// 注册方法获取WebViewJavascriptBridge对象
function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  // 兼容安卓
  document.addEventListener(
    "WebViewJavascriptBridgeReady",
    () => callback(window.WebViewJavascriptBridge),
    false
  );
  // 兼容ios
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

//  获取WebViewJavascriptBridge对象
function getBirdge() {
  if (bridePromise) return bridePromise;
  bridePromise = new Promise(resolve => {
    if (window.WebViewJavascriptBridge) {
      return resolve(window.WebViewJavascriptBridge);
    }
    setupWebViewJavascriptBridge(bridge => {
      resolve(bridge);
    });
  });
  return bridePromise;
}

// 重写之后的birdge
const bridge = {
  ctx: null, // WebViewJavascriptBridge
  // 通信方法
  callHandler(data, fn) {
    return new Promise(async resolve => {
      // 不是咱们的app提示
      if (!isMyApp) {
        // toast("请下载礼成APP编辑");
        return Promise.reject("please download lichengApp!");
      }
      if (!this.ctx) {
        this.ctx = await getBirdge();
      }
      // 根据业务场景重写数据
      this.ctx.callHandler("invitationEdit", JSON.stringify(data), res => {
        resolve(res);
        fn && fn(res);
      });
    });
  },
  // 注册事件
  async registerHandler(nanme, fn) {
    if (!this.ctx) {
      this.ctx = await getBirdge();
    }
    // 重写事件注册方法
    this.ctx.registerHandler(nanme, (data, callback) => {
      // 回调返回数据
      fn && fn(data);
      callback && callback(`网页收到事件${nanme}`);
    });
  }
};

export default bridge;
